import { render, staticRenderFns } from "./RequestMatchingArchivesDeclineControls.vue?vue&type=template&id=2fb4f17b&v-else=true&"
import script from "./RequestMatchingArchivesDeclineControls.vue?vue&type=script&lang=js&"
export * from "./RequestMatchingArchivesDeclineControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VIcon})
